<!--

    Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
    Ministerpräsidenten des Landes Schleswig-Holstein
    Staatskanzlei
    Abteilung Digitalisierung und zentrales IT-Management der Landesregierung

    Lizenziert unter der EUPL, Version 1.2 oder - sobald
    diese von der Europäischen Kommission genehmigt wurden -
    Folgeversionen der EUPL ("Lizenz");
    Sie dürfen dieses Werk ausschließlich gemäß
    dieser Lizenz nutzen.
    Eine Kopie der Lizenz finden Sie hier:

    https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12

    Sofern nicht durch anwendbare Rechtsvorschriften
    gefordert oder in schriftlicher Form vereinbart, wird
    die unter der Lizenz verbreitete Software "so wie sie
    ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
    ausdrücklich oder stillschweigend - verbreitet.
    Die sprachspezifischen Genehmigungen und Beschränkungen
    unter der Lizenz sind dem Lizenztext zu entnehmen.

-->
@if (buttonConfig().label; as label) {
  <ods-button
    [variant]="buttonConfig().variant"
    [destructive]="buttonConfig().destructive"
    [text]="label"
    [icon]="buttonConfig().iconName"
    data-test-id="decision-dialog-trigger-button"
    (clicked)="dialog.open()"
  />
} @else {
  <ods-button
    [variant]="buttonConfig().variant"
    [destructive]="buttonConfig().destructive"
    size="fit"
    [icon]="buttonConfig().iconName"
    [tooltip]="buttonConfig().tooltip"
    tooltipAriaType="aria-label"
    data-test-id="decision-dialog-trigger-icon-button"
    (clicked)="dialog.open()"
  />
}
<odc-decision-dialog
  #dialog
  [headline]="dialogConfig().headline"
  [subHeadline]="dialogConfig().subHeadline"
  [content]="dialogConfig().content"
  [applyButton]="dialogConfig().applyButton"
  [stateResource]="dialogConfig().stateResource"
  [closeWhen]="dialogConfig().closeWhen"
  (apply)="apply.emit()"
/>
